import browserUpdate from 'browser-update';
import { i18n } from './i18n/translate.js';

/* eslint id-length: ["error", { "exceptions": ["c", "e", "f", "i", "o", "o_a", "s", "uc", "v", "y"] }] */

var closeModal = function closeModal() {
  document.body.classList.remove('browser-update-modal');
  var modalBackdrop = document.getElementById('browser-update-backdrop');
  document.body.removeChild(modalBackdrop);
};
var getDefaultText = function getDefaultText() {
  return {
    bignore: i18n.t('Ignore'),
    bupdate: i18n.t('Update Browser'),
    msg: i18n.t('A new version of your browser ({brow_name}) is available.'),
    msgmore: i18n.t('Please update your browser for the best performance.')
  };
};
var getUnsupportedBrowserText = function getUnsupportedBrowserText() {
  return {
    msg: i18n.t('This browser is not supported. For best performance please use the latest version of Chrome, Firefox, or Safari.'),
    msgmore: "<a href=\"https://everfi.com/minimum-system-requirements/\" class=\"branded-link primary\" target=\"_blank\" rel=\"noopener noreferrer\">".concat(i18n.t('View system requirements'), " <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></a>")
  };
};
var onShow = function onShow() {
  var browserUpdateDiv = document.getElementById('buorg');
  browserUpdateDiv.classList.add('foundry');

  // insert dark overlay for modal backdrop
  var modalBackdrop = document.createElement('div');
  modalBackdrop.id = 'browser-update-backdrop';
  document.body.insertBefore(modalBackdrop, document.body.firstChild);
  var primaryBtn = document.getElementById('buorgul');
  primaryBtn.id = 'update-browser-btn';
  primaryBtn.className = 'btn btn-primary btn-primary-branded';
  var secondaryBtn = document.getElementById('buorgig');
  secondaryBtn.id = 'ignore-btn';
  secondaryBtn.className = 'btn btn-secondary btn-secondary-branded';
};
var BrowserUpdate = function BrowserUpdate() {
  var unsupported = 999;
  var unsupportedMessaging = getUnsupportedBrowserText();
  browserUpdate({
    container: document.body,
    insecure: true,
    // Notify user if using insecure browser
    jsshowurl: '//browser-update.org/update.show.min.js',
    // URL where the script, that shows the notification, is located. This is only loaded if the user actually has an outdated browser.
    no_permanent_hide: true,
    // Hides "Never Show Again" secondary modal
    onclick: function onclick() {
      closeModal();
    },
    onclose: function onclose() {
      closeModal();
    },
    onshow: function onshow() {
      onShow();
    },
    required: {
      c: 0,
      // Chrome
      e: 0,
      // Edge
      f: 0,
      // Firefox
      i: unsupported,
      // Internet Explorer
      o: unsupported,
      // Opera
      o_a: unsupported,
      // Opera (Android)
      s: 0,
      // Safari
      samsung: unsupported,
      // Samsung Internet (Android)
      uc: unsupported,
      // UC Browser
      v: unsupported,
      // Vivaldi
      y: unsupported // Yandex Browser
    },
    style: 'corner',
    // test: true, // Uncomment to toggle display for testing
    text: getDefaultText(),
    text_for_i: unsupportedMessaging,
    text_for_o: unsupportedMessaging,
    text_for_o_a: unsupportedMessaging,
    text_for_samsung: unsupportedMessaging,
    text_for_uc: unsupportedMessaging,
    text_for_v: unsupportedMessaging,
    text_for_y: unsupportedMessaging,
    unsupported: true // Notify user when using "unsupported" browser
  });
};
export { BrowserUpdate };